export default __webpack_public_path__ + "static/media/consdritamarperez.ea841ba0.jpg";